export const DASHBAORD_TYPES =
    [
        { id: 1, type: 'PATIENT_DASHBOARD', description: 'Patient\'s Dashboard' },
        { id: 2, type: 'CLINICIAN_DASHBOARD', description: 'Clinician\'s Dashboard' },
        { id: 3, type: 'ADMIN_DASHBOARD', description: 'Administrator\'s Dashboard' },
        { id: 4, type: 'CLINICIAN_PATIENT_DASHBOARD', description: 'Clinician patient management Dashboard' },
        { id: 5, type: 'ADMIN_PATIENT_DASHBOARD', description: 'Administrator patient management Dashboard' },
    ]